import { StoreItem } from "../data-types/data-types";

export const dummyStore: StoreItem[] = [
	{ id: "1", redirect_url: "", price: "", sale_price: "", title: "", image: "", },
	{ id: "2", redirect_url: "", price: "", sale_price: "", title: "", image: "", },
	{ id: "3", redirect_url: "", price: "", sale_price: "", title: "", image: "", },
	{ id: "5", redirect_url: "", price: "", sale_price: "", title: "", image: "", },
]